<template>
  <div style="min-witdh: 1500px">
    <div class="footer">
      <div class="common">
        <div class="footer-left">
          <div class="footer-left-img">
            <img src="../assets/img/footer-logo.png" alt />
          </div>
          <ul>
            <li>联系电话：023-67030166</li>
            <li>邮箱地址：office@cqzxyatai.com</li>
            <li>联系地址：重庆市南岸区复兴街9号中讯时代6楼</li>
          </ul>
        </div>
        <div class="footer-right">
          <div class="footer-right-top">
            <ul>
              <li @click="handleTo('/')">首页</li>
            </ul>
            <ul>
              <li @click="handleTo('/service', 0)">亚太服务</li>
              <li @click="handleTo('/service', 0)">系统集成服务</li>
              <li @click="handleTo('/service', 1)">运维服务</li>
              <li @click="handleTo('/service', 2)">电子认证服务</li>
            </ul>
            <ul>
              <li @click="handleTo('/product', 0)">亚太产品</li>
              <li @click="handleTo('/product', 0)">信息系统集成软件产品</li>
              <li @click="handleTo('/product', 1)">电子认证服务产品</li>
              <li @click="handleTo('/product', 2)">代理产品</li>
            </ul>
            <ul>
              <li @click="handleTo('/about', 0)">关于亚太</li>
              <li @click="handleTo('/about', 0)">企业简介</li>
              <li @click="handleTo('/about', 1)">新闻公告</li>
              <li @click="handleTo('/about', 2)">企业文化</li>
              <li @click="handleTo('/about', 3)">资质荣誉</li>
            </ul>
            <ul>
              <li @click="handleTo('/connect', 0)">联系我们</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-dibu">
      Copyright&nbsp;@&nbsp;2021 重庆中讯亚太信息技术有限公司&nbsp;版权所有&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">渝ICP备2021001555号-1&nbsp;&nbsp;&nbsp;</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010802003879" target="_blank">渝公网安备50010802003879</a>
    </div>
  </div>

</template>

<script>
export default {
  name: "Footer",

  methods: {
    handleTo(path, activeNo = 0) {
      this.$router.push({
        path,
        query: {
          activeNo,
        },
      });
    },
  },
};
</script>

<style scoped>
.footer {
  width: 100%;
  height: 500px;
  background-color: #000;
  color: #fff;
  padding-top: 90px;
  text-align: left;
}
.footer-dibu{
  width: 100%;
  font-size: 13px;
  float: none;
  background-color: #656060;
  color: #fff;
}
.footer-left {
  float: left;
  width: 530px;
  font-size: 20px;
  line-height: 67px;
}
.footer-left-img {
  width: 306px;
  height: 88px;
  margin-bottom: 40px;
}
.footer-left-img img {
  width: 100%;
  height: 100%;
}
.footer-right {
  float: right;
  width: 900px;
  line-height: 50px;
  font-size: 20px;
}
.footer-right-top {
  display: flex;
  height: 260px;
  justify-content: space-around;
}
.footer-right ul li {
  font-size: 16px;
}
.footer-right ul li:nth-child(1) {
  font-size: 22px;
  margin-right: 40px;
  font-weight: 800;
}
a {
  color: #fff !important;
}
li:hover {
  cursor: pointer;
}

@media screen and (max-width: 1500px) {
  .footer {
    height: 600px;
    padding-top: 30px;
  }
  .footer-left {
    float: left;
    width: 300px;
    font-size: 20px;
    line-height: 67px;
  }
  .footer-left-img {
    width: 260px;
    height: 80px;
    margin-bottom: 20px;
  }
  .footer-right {
    float: right;
    width: 580px;
    line-height: 50px;
    font-size: 20px;
  }
  .footer-right ul {
  }

  .footer-right ul li:nth-child(1) {
    font-size: 20px;
    width: 120px;
    font-weight: 800;
  }
}
@media screen and (max-width: 1080px) {
  .footer {
    height: 460px;
    padding-top: 30px;
  }
  .footer-left {
    float: left;
    width: 300px;
    font-size: 20px;
    line-height: 67px;
  }
  .footer-left-img {
    width: 260px;
    height: 80px;
    margin-bottom: 20px;
  }
  .footer-right {
    float: right;
    width: 580px;
    line-height: 50px;
    font-size: 20px;
  }
  .footer-right ul li:nth-child(1) {
    font-size: 20px;
    font-weight: 800;
  }
}
</style>